import React, { useState, useRef, useEffect } from "react";
import "./style.css";

export function TooltipProvider({ children }) {
  return <>{children}</>;
}

// export function Tooltip({ children }) {
//   return <div className="tooltip-root">{children}</div>;
// }

export function TooltipTrigger({ children }) {
  return children;
}

export function TooltipContent({
  children,
  side = "top",
  sideOffset = 4,
  className = "",
}) {
  const [visible, setVisible] = useState(false);
  const [actualSide, setActualSide] = useState(side);
  const [prevSide, setPrevSide] = useState(side);
  const triggerRef = useRef(null);
  const contentRef = useRef(null);

  useEffect(() => {
    const trigger = triggerRef.current?.parentElement;
    if (!trigger) return;

    const show = () => setVisible(true);
    const hide = () => setVisible(false);

    trigger.addEventListener("mouseenter", show);
    trigger.addEventListener("mouseleave", hide);
    trigger.addEventListener("focus", show);
    trigger.addEventListener("blur", hide);

    return () => {
      trigger.removeEventListener("mouseenter", show);
      trigger.removeEventListener("mouseleave", hide);
      trigger.removeEventListener("focus", show);
      trigger.removeEventListener("blur", hide);
    };
  }, []);

  useEffect(() => {
    if (!visible) return;

    const content = contentRef.current;
    const trigger = triggerRef.current?.parentElement;
    if (!content || !trigger) return;

    const triggerRect = trigger.getBoundingClientRect();
    const contentRect = content.getBoundingClientRect();
    const spacing = sideOffset;

    let newSide = side;

    if (side === "top" && triggerRect.top - contentRect.height - spacing < 0) {
      newSide = "bottom";
    }
    if (side === "bottom" && triggerRect.bottom + contentRect.height + spacing > window.innerHeight) {
      newSide = "top";
    }
    if (side === "left" && triggerRect.left - contentRect.width - spacing < 0) {
      newSide = "right";
    }
    if (side === "right" && triggerRect.right + contentRect.width + spacing > window.innerWidth) {
      newSide = "left";
    }

    setPrevSide(actualSide);
    setActualSide(newSide);
  }, [visible, side, sideOffset]);

  return (
    <>
      <span ref={triggerRef}></span>
      {visible && (
        <div
          ref={contentRef}
          className={`tooltip-content ${actualSide} ${prevSide} ${className}`}
          style={{ margin: sideOffset }}
        >
          {children}
          <span className={`tooltip-arrow ${actualSide}`} />
        </div>
      )}
    </>
  );
}


// Example usage:

// import { TooltipProvider, Tooltip, TooltipTrigger, TooltipContent } from "./Tooltip";

// export default function Example() {
//   return (
//     <TooltipProvider>
//       <Tooltip>
//         <TooltipTrigger>
//           <button className="btn">Hover me</button>
//         </TooltipTrigger>
//         <TooltipContent side="bottom">
//           This is a tooltip with an arrow!
//         </TooltipContent>
//       </Tooltip>
//     </TooltipProvider>
//   );
// }
